<script setup lang="ts">
import type { DetailsCarItemData } from '@autobid/ui/types/Car'
import { formatStartDate } from '@autobid/ui/utils/auctions/formatStartDate'
import { formatDate } from '@autobid/ui/utils/date/formatDate'
import { getDayName } from '@autobid/ui/utils/date/getDayName'

interface Props {
  car: DetailsCarItemData
  barometerUrl?: string
}

defineProps<Props>()

const { locale } = useI18n()
</script>

<template>
  <div
    class="-mx-3 flex w-[calc(100%+1.5rem)] bg-primary px-2 py-3.5 lg:mx-0 lg:w-full lg:bg-transparent lg:px-0 lg:pb-1 lg:pt-0"
  >
    <div
      class="flex w-full border-b border-primary text-white lg:mr-4 lg:font-bold lg:text-inherit"
    >
      <common-link class="mr-4 lg:hidden" :href="barometerUrl">
        <CommonIconArrow class="h-10 w-10" />
      </common-link>
      <div
        class="flex flex-col justify-between lg:w-full lg:flex-row lg:items-center"
      >
        <p class="mb-2 font-bold uppercase lg:mb-0 lg:text-2xl">
          {{ $t('car-details.title') }}
        </p>
        <p>
          <span class="block font-bold lg:inline-block">
            {{ $t('auction-list.auction-number') }}
            {{ car.auctionNumber }}
          </span>
          <span v-if="car.auctionStartDate" class="text-sm lg:text-base">
            <span class="hidden lg:inline-block">&nbsp;|</span>
            <span class="md:hidden">
              {{
                getDayName(car.auctionStartDate, {
                  weekday: 'short',
                  lang: locale,
                })
              }}
            </span>
            {{ formatDate(car.auctionStartDate) }}&nbsp; |
            <span class="hidden lg:inline-block">{{ $t('start') }}</span>
            {{
              formatStartDate(car.auctionStartDate, { showFullDate: false, $t })
            }}
          </span>
        </p>
      </div>
    </div>

    <ElementsCarListButton
      :auction-id="car.auctionId"
      :app-id="car.appId"
      class="mr-0.5 lg:mr-0 lg:mt-[var(--details-all-cars-btn-mt,0)]"
    />
  </div>
</template>
